/* Laitilio – ficha de producto: cantidad con descuento, resumen y cambio de variante (productos hermanos) sin recargar */
(function () {
  if (window.__ltPdp) return;
  window.__ltPdp = true;

  function fmt(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = format || '${{amount}}';
    function delim(n, d, t, s) {
      var parts = (n / 100).toFixed(d).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? s + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return delim(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return delim(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return delim(cents, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return delim(cents, 2, "'", '.');
      return delim(cents, 2, ',', '.');
    });
  }

  function scopeOf(el) { return el.closest('.shopify-section') || document; }

  class LtQtyOffer extends HTMLElement {
    connectedCallback() {
      try { this.cfg = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      this.scope = scopeOf(this);
      var start = Number(window.__ltQty) || this.cfg.start || 1;
      this.qty = start;
      this.custom = !this.cfg.tiers.some(function (t) { return t.q === start; });
      var self = this;
      this.menu = this.querySelector('[data-q-menu]');
      this.querySelectorAll('[data-q]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (b.dataset.q === 'custom') {
            e.stopPropagation();
            if (self.menu) { var open = self.menu.hidden; self.menu.hidden = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false'); }
            return;
          }
          self.custom = false; self.closeMenu(); self.setQty(Number(b.dataset.q));
        });
      });
      this.querySelectorAll('[data-qc]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation(); self.custom = true; self.closeMenu(); self.setQty(Number(b.dataset.qc));
        });
      });
      this._outside = function (e) { if (!self.contains(e.target)) self.closeMenu(); };
      document.addEventListener('click', this._outside);
      setTimeout(function () { self.update(); self.fitTags(); }, 0);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.fitTags(); });
      this._rs = function () { self.fitTags(); self.atcButtons().forEach(function (b) { self.fitButton(b); }); }; window.addEventListener('resize', this._rs);
      this.timer = setInterval(function () { self.poll(); }, 400);
    }
    disconnectedCallback() { clearInterval(this.timer); document.removeEventListener('click', this._outside); window.removeEventListener('resize', this._rs); }
    atcButtons() {
      return Array.prototype.filter.call(this.scope.querySelectorAll('[ref="addToCartButton"]'), function (b) { return !b.classList.contains('sticky-add-to-cart__button') && !b.closest('sticky-add-to-cart, .sticky-add-to-cart'); });
    }
    fitButton(btn) {
      btn.style.removeProperty('font-size');
      var fs = parseFloat(getComputedStyle(btn).fontSize) || 15, guard = 0;
      while (btn.scrollWidth > btn.clientWidth + 1 && fs > 11 && guard++ < 20) { fs -= 0.5; btn.style.fontSize = fs + 'px'; }
    }
    fitTags() {
      var box = this.querySelector('.lt-qo__tags'); if (!box) return;
      box.style.removeProperty('--tag-fs');
      var fs = parseFloat(getComputedStyle(box.querySelector('.lt-qo__tag') || box).fontSize) || 15;
      var guard = 0;
      while (box.scrollWidth > box.clientWidth + 1 && fs > 9 && guard++ < 30) { fs -= 0.5; box.style.setProperty('--tag-fs', fs + 'px'); }
    }
    closeMenu() { if (this.menu) { this.menu.hidden = true; var b = this.querySelector('[data-q="custom"]'); if (b) b.setAttribute('aria-expanded', 'false'); } }
    form() { return this.scope.querySelector('form[data-type="add-to-cart-form"]') || this.scope.querySelector('form[action*="/cart/add"]'); }
    variant() {
      var f = this.form(); var inp = f && f.querySelector('input[name="id"]');
      var id = inp ? String(inp.value) : '';
      var vs = this.cfg.variants;
      for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === id) return vs[i];
      return vs[0];
    }
    discountFor(q) {
      var d = 0;
      this.cfg.tiers.forEach(function (t) { if (q >= t.q && t.d > d) d = t.d; });
      return d;
    }
    setQty(q) { this.qty = Math.max(1, q || 1); window.__ltQty = this.qty; this.update(); }
    poll() {
      var v = this.variant();
      var f = this.form(); var qi = f && f.querySelector('input[name="quantity"]');
      var missing = false;
      this.atcButtons().forEach(function (b) { if (!b.querySelector('.lt-atc-total')) missing = true; });
      if ((v && v.id !== this.lastId) || (qi && String(qi.value) !== String(this.qty)) || (this.cfg.price_in_button && missing)) this.update();
    }
    update() {
      var v = this.variant(); if (!v) return;
      this.lastId = v.id;
      var q = this.qty, d = this.discountFor(q), money = this.cfg.money;
      var gross = v.price * q, off = Math.round(gross * d / 100), sub = gross - off;
      var self = this;

      // cantidad en el formulario nativo (oculto)
      var f = this.form();
      if (f) f.querySelectorAll('input[name="quantity"]').forEach(function (i) { i.value = q; });

      // botones
      this.querySelectorAll('[data-q]').forEach(function (b) {
        var on = b.dataset.q === 'custom' ? self.custom : (!self.custom && Number(b.dataset.q) === q);
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var lab = this.querySelector('[data-q-label]'); if (lab) lab.textContent = q;
      var cl = this.querySelector('[data-q-custom-label]');
      if (cl) cl.textContent = this.custom ? q + ' ' + (this.cfg.unit_many || '') : (this.cfg.custom_label || 'Otra');
      this.querySelectorAll('[data-qc]').forEach(function (b) { b.classList.toggle('is-active', self.custom && Number(b.dataset.qc) === q); });

      // precio en el botón de carrito
      if (this.cfg.price_in_button) {
        this.atcButtons().forEach(function (btn) {
          var span = btn.querySelector('.lt-atc-total');
          if (!span) {
            span = document.createElement('span'); span.className = 'lt-atc-total';
            var host = btn.querySelector('.add-to-cart-text__content') || btn.querySelector('.add-to-cart-text');
            if (host) host.appendChild(span);
            else { var added = btn.querySelector('.add-to-cart__added'); added ? btn.insertBefore(span, added) : btn.appendChild(span); }
          }
          span.textContent = ' – ' + fmt(sub, money);
          self.fitButton(btn);
        });
      }
      // quitar el total de la barra fija (botón redondo solo con icono)
      this.scope.querySelectorAll('.sticky-add-to-cart__button .lt-atc-total').forEach(function (x) { x.remove(); });

      // resumen
      this.scope.querySelectorAll('[data-lt-summary]').forEach(function (s) {
        s.querySelector('[data-sum-gross]').textContent = fmt(gross, money);
        s.querySelector('[data-sum-off]').textContent = '-' + fmt(off, money);
        s.querySelector('[data-sum-sub]').textContent = fmt(sub, money);
        s.querySelectorAll('[data-sum-if-off]').forEach(function (r) { r.hidden = off <= 0; });
      });

      // precio de la cabecera
      this.scope.querySelectorAll('[data-lt-price]').forEach(function (e) { e.textContent = fmt(v.price, money); });
      this.scope.querySelectorAll('[data-lt-compare]').forEach(function (e) {
        var show = v.compare_at_price > v.price; e.hidden = !show; if (show) e.textContent = fmt(v.compare_at_price, money);
      });
      this.scope.querySelectorAll('[data-lt-save]').forEach(function (e) {
        var pct = v.compare_at_price > v.price ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        e.hidden = pct <= 0; var b = e.querySelector('b'); if (b) b.textContent = pct;
      });
    }
  }
  if (!customElements.get('lt-qty-offer')) customElements.define('lt-qty-offer', LtQtyOffer);

  // Productos hermanos: cambia imágenes y precio sin recargar (precargados para que el cambio sea instantáneo)
  var cache = {};
  function sectionUrl(href, id) { return href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id); }
  function load(href, id) {
    var key = href + '|' + id;
    if (!cache[key]) {
      cache[key] = fetch(sectionUrl(href, id), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status); return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('img').forEach(function (im, i) {
          if (i > 7) return;
          var pre = new Image();
          if (im.getAttribute('sizes')) pre.sizes = im.getAttribute('sizes');
          if (im.getAttribute('srcset')) pre.srcset = im.getAttribute('srcset');
          if (im.getAttribute('src')) pre.src = im.getAttribute('src');
        });
        return html;
      });
      cache[key].catch(function () { delete cache[key]; });
    }
    return cache[key];
  }
  function prefetchAll() {
    document.querySelectorAll('[data-lt-sibs]').forEach(function (box) {
      var sec = box.closest('.shopify-section'); if (!sec || !sec.id) return;
      var id = sec.id.replace(/^shopify-section-/, '');
      box.querySelectorAll('a[data-lt-sib]:not(.is-active)').forEach(function (a) { load(a.href, id); });
    });
  }
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 300); };
  if (document.readyState === 'complete') idle(prefetchAll); else window.addEventListener('load', function () { idle(prefetchAll); });
  document.addEventListener('pointerover', function (e) {
    var a = e.target.closest && e.target.closest('a[data-lt-sib]'); if (!a) return;
    var sec = a.closest('.shopify-section'); if (sec && sec.id) load(a.href, sec.id.replace(/^shopify-section-/, ''));
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-lt-sib]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    if (a.classList.contains('is-active')) return;
    var sec = a.closest('.shopify-section');
    if (!sec || !sec.id || !window.fetch || !window.DOMParser) { window.location.href = a.href; return; }
    var id = sec.id.replace(/^shopify-section-/, '');
    var box = a.closest('[data-lt-sibs]');
    if (box) box.querySelectorAll('a[data-lt-sib]').forEach(function (x) { x.classList.toggle('is-active', x === a); });
    load(a.href, id).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById(sec.id) || doc.querySelector('.shopify-section');
      if (!fresh || !fresh.querySelector('[data-lt-sibs], lt-qty-offer')) throw new Error('no section');
      fresh.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.setAttribute('loading', 'eager'); });
      var y = window.scrollY;
      fresh = document.importNode(fresh, true);
      fresh.querySelectorAll('script').forEach(function (old) {
        var t = (old.getAttribute('type') || '').toLowerCase();
        if (t && t !== 'text/javascript') return;
        var s2 = document.createElement('script');
        for (var i = 0; i < old.attributes.length; i++) s2.setAttribute(old.attributes[i].name, old.attributes[i].value);
        s2.textContent = old.textContent; old.replaceWith(s2);
      });
      sec.replaceWith(fresh);
      window.scrollTo(0, y);
      try { history.replaceState(history.state, '', a.href); } catch (_) {}
      if (a.dataset.title) document.title = a.dataset.title;
      idle(prefetchAll);
    }).catch(function () { window.location.href = a.href; });
  });
})();
